import axios from 'axios';
import Cookies from 'universal-cookie';
import {showErrorEv} from '../infoModel/index.js';

const cookies = new Cookies();

export async function revokeTokens() {
    //for rebuild
    const token = cookies.get('access_token');
    if (!token) return true;
    const params = {
        client_id: SSO_CLIENT_KEY,
        token
    };
    const data = new URLSearchParams(params).toString();
    cookies.remove('access_token', {path: '/'})
    cookies.remove('refresh_token', {path: '/'})
    cookies.remove('pkce_code_verifier', {path: '/'})
    cookies.remove('user_info', {path: '/'})
    cookies.remove('csrftoken', {path: '/'})
    cookies.remove('sessionid', {path: '/'})
    await axios.post(
        SSO_LOGOUT_URL,
        data,
        {headers: {'Content-Type': 'application/x-www-form-urlencoded',}}
    )
    return true
}

export async function initApp() {
    if (window.location.origin.includes('localhost')) {
        return true
    }
    const urlParams = new URLSearchParams(window.location.search);
    const codeStr = urlParams.get('code');
    const accessToken = cookies.get('access_token', {path: '/'});
    const refreshToken = cookies.get('refresh_token', {path: '/'});

    if (accessToken && refreshToken) {
        return true
    } else if (codeStr) {
        return await fetchTokens(codeStr);
    } else {
        await tokenGet();
    }
}

export async function tokenGet() {
    const codeVerifier = await generateCodeVerifier();
    const codeChallenge = await generateCodeChallenge(codeVerifier);

    cookies.set('pkce_code_verifier', codeVerifier, {path: '/'});

    const params = {
        response_type: 'code',
        state: makeid(64),
        nonce: makeid(64),
        scope: SSO_SCOPES,
        client_id: SSO_CLIENT_KEY,
        redirect_uri: SSO_REDIRECT_URL,
        code_challenge: codeChallenge,
        code_challenge_method: 'S256',
    };

    const queryString = new URLSearchParams(params).toString();
    window.location.replace(`${SSO_AUTHORIZATION_URL}?${queryString}`);
}

export async function fetchTokens(code) {
    const codeVerifier = cookies.get('pkce_code_verifier', {path: '/'});
    if (!codeVerifier) {
        console.error('Code verifier not found');
        showErrorEv({summary: 'Ошибка', detail: 'Код верификации не найден'})
        return false;
    }

    try {
        const params = {
            grant_type: 'authorization_code',
            code: code,
            redirect_uri: SSO_REDIRECT_URL,
            client_id: SSO_CLIENT_KEY,
            code_verifier: codeVerifier,
        };
        const data = new URLSearchParams(params).toString();

        const response = await axios.post(SSO_TOKEN_URL, data, {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            },
        });

        const accessToken = response.data.access_token;
        const refreshToken = response.data.refresh_token;

        cookies.set('access_token', accessToken, {path: '/'});
        cookies.set('refresh_token', refreshToken, {path: '/'});

        // Удаляем code_verifier из cookies после использования
        cookies.remove('pkce_code_verifier', {path: '/'});

        return true
    } catch (error) {
        console.error('Ошибка получения токенов:', error);
        showErrorEv({summary: 'Ошибка', detail: 'Ошибка получения токенов'})
        return false
    }
}

export async function getUserInfo(forceUpdate = false) {
    const token = cookies.get('access_token', {path: '/'});
    const userInCookies = cookies.get('user_info', {path: '/'});

    if (!token) {
        console.error('Токен не инициализирован');
        showErrorEv({summary: 'Ошибка', detail: 'Токен не инициализирован'})
        return null;
    }

    if (userInCookies && !forceUpdate) {
        return userInCookies;
    }

    let user = null;

    try {
        const res = (await axios.get(SSO_USER_INFO_URL, {
            headers: {Authorization: 'Bearer ' + token},
        })).data;
        user = res
        cookies.set('user_info', JSON.stringify(user), {path: '/'});
    } catch (error) {
        console.error('Ошибка получения информации о пользователе:', error);
        showErrorEv({summary: 'Ошибка', detail: 'Ошибка получения информации о пользователе'})
        return null;
    }
    return user;
}

function makeid(length) {
    let result = '';
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const charactersLength = characters.length;
    let counter = 0;
    while (counter < length) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
        counter += 1;
    }
    return result;
}

async function generateCodeVerifier() {
    const array = new Uint8Array(32);
    window.crypto.getRandomValues(array);
    return base64UrlEncode(array);
}

async function generateCodeChallenge(codeVerifier) {
    const encoder = new TextEncoder();
    const data = encoder.encode(codeVerifier);
    const digest = await window.crypto.subtle.digest('SHA-256', data);
    return base64UrlEncode(new Uint8Array(digest));
}

function base64UrlEncode(array) {
    return btoa(String.fromCharCode.apply(null, Array.from(array)))
        .replace(/\+/g, '-')
        .replace(/\//g, '_')
        .replace(/=+$/, '');
}